import { Label } from '@atoms/index';
import { NavigationButtons } from '@molecules/index';
import { useNavigate } from 'react-router-dom';

interface ContactTemplatePageProps {
  title: string;
  content: string | React.ReactNode;
}

export const ContactTemplatePage = ({
  title,
  content,
}: ContactTemplatePageProps) => {
  const navigate = useNavigate();
  const buttonPrevious = {
    label: 'Previous',
    onClick: () => {
      navigate(-1);
    },
  };
  const buttonNext = {
    label: 'Back to homepage',
    onClick: () => {
      window.location.href = 'https://www.westminster.gov.uk/report-it';
    },
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="mt-[25px] ">
        <Label text={title} className="text-brand-primary" isTitle={true} />
      </div>
      <div>{content}</div>
      <NavigationButtons
        buttonPrevious={buttonPrevious}
        buttonNext={buttonNext}
      />
    </div>
  );
};
